import { ReactNode } from "react";
import styles from "./OffScreen.module.scss";

interface OffScreenProps extends React.HTMLAttributes<HTMLElement> {
  children: ReactNode;
  tagName?: "div" | "span";
}

export default function OffScreen({
  children,
  tagName: Tag = "div",
  ...restProps
}: OffScreenProps) {
  return (
    <Tag className={styles.container} {...restProps}>
      {children}
    </Tag>
  );
}
